import { checkColor } from '@app/utils';
import { StyleSheet, Platform } from 'react-native';

const ls = StyleSheet.create({
  button: {
    height: 40,
    borderWidth: 1,
    borderColor: checkColor('#1434CB'),
    borderRadius: 24,
    width: '100%',
  },
  buttonShadow: {
    elevation: 24,
    shadowColor: checkColor('#1434CB'),
    ...(Platform.OS === 'ios' && {
      shadowOffset: { width: 0, height: 16 },
      shadowOpacity: 0.25,
      shadowRadius: 12,
    }),
    // marginHorizontal: Dimensions.get('screen').width > 450 ? 16 : 0,
    ...(Platform.OS === 'web' && {
      boxShadow: '0 16px 24px 0 rgba(20, 52, 203, 0.25)',
    }),
  },
  outlinedButton :{

  },
  outlinedButtonPressed:{
    
  },
  textButton:{

  },
  containedButton:{
  
  },
  containedButtonPressed:{

  }
});
export default ls;
